import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("cdl_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const api = {
  login: (email, password) => client.post("/auth/login", { email, password }),
  me: () => client.get("/auth/me"),
  listProducts: () => client.get("/products"),
  createProduct: (p) => client.post("/products", p),
  updateProduct: (id, p) => client.patch(`/products/${id}`, p),
  deleteProduct: (id) => client.delete(`/products/${id}`),
  listQuotes: () => client.get("/quotes"),
  saveQuote: (q) => client.post("/quotes", q),
  updateQuoteStatus: (id, status) => client.patch(`/quotes/${id}/status`, { status }),
  deleteQuote: (id) => client.delete(`/quotes/${id}`),
  listCategories: () => client.get("/categories"),
  updateCategory: (kind, data) => client.patch(`/categories/${kind}`, data),
  listServices: () => client.get("/services"),
  createService: (s) => client.post("/services", s),
  updateService: (id, s) => client.patch(`/services/${id}`, s),
  deleteService: (id) => client.delete(`/services/${id}`),
};
